import { vueWrapper } from "@/vue-wrapper";

vueWrapper.onLoad();
